<div class="cs-overlay" (click)="closePopup()" style="background:rgb(152, 152, 152)">
  <div
    class="cs-popup"
    role="dialog"
    aria-modal="true"
    aria-labelledby="contact-support-title"
    (click)="$event.stopPropagation()">

    <button
      type="button"
      class="cs-popup__close"
      (click)="closePopup()"
      [attr.aria-label]="'label_close' | translate">
      <i class="pi pi-times"></i>
    </button>

    <div class="cs-popup__intro">
      <div class="cs-popup__hero-icon" aria-hidden="true">
        <img src="/assets/images/temp/support-headset-white.svg" alt="" />
      </div>
      <h1 id="contact-support-title" class="cs-popup__title" translate>label_contact_support</h1>
      <p class="cs-popup__subtitle" translate>label_contact_support_subtitle</p>
    </div>

    <div class="cs-popup__card">
      <div class="cs-popup__card-banner">
        <span translate>label_your_support_contact</span>
      </div>

      <div class="cs-popup__card-body">
        <div class="cs-popup__agent">
          <div class="cs-popup__avatar-wrap">
            <div class="cs-popup__avatar" aria-hidden="true">
              <i class="pi pi-mobile"></i>
            </div>
            <span class="cs-popup__avatar-dot" *ngIf="isAvailable"></span>
          </div>

          <div class="cs-popup__agent-meta">
            <div class="cs-popup__agent-name-row">
              <h2 class="cs-popup__agent-name">{{ organisationName }}</h2>
              <i class="pi pi-check-circle cs-popup__verified" aria-hidden="true"></i>
            </div>
            <p class="cs-popup__agent-role" *ngIf="supportRole">{{ supportRole }}</p>
            <p class="cs-popup__agent-status" *ngIf="isAvailable">
              <span class="cs-popup__status-dot"></span>
              <span translate>label_available_now</span>
            </p>
          </div>
        </div>

        <div class="cs-popup__groups-scroll" *ngIf="contactGroups.length">
          <div
            class="cs-popup__group"
            *ngFor="let group of contactGroups; trackBy: trackBySupportLabel">
            <p class="cs-popup__group-label">{{ group.label }}</p>
            <div class="cs-popup__tiles">
              <a
                class="cs-popup__tile"
                *ngIf="group.phone"
                [href]="getPhoneHref(group.phone)">
                <span class="cs-popup__tile-icon" aria-hidden="true">
                  <i class="pi pi-phone"></i>
                </span>
                <span class="cs-popup__tile-copy">
                  <span class="cs-popup__tile-label" translate>label_phone</span>
                  <span class="cs-popup__tile-value">{{ group.phone }}</span>
                </span>
              </a>

              <a
                class="cs-popup__tile"
                *ngIf="group.email"
                [href]="getEmailHref(group.email)">
                <span class="cs-popup__tile-icon" aria-hidden="true">
                  <i class="pi pi-envelope"></i>
                </span>
                <span class="cs-popup__tile-copy">
                  <span class="cs-popup__tile-label" translate>label_email</span>
                  <span class="cs-popup__tile-value">{{ group.email }}</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cs-popup__hours" *ngIf="supportHours">
      <div class="cs-popup__hours-main">
        <div class="cs-popup__hours-icon" aria-hidden="true">
          <i class="pi pi-clock"></i>
        </div>
        <div class="cs-popup__hours-copy">
          <span class="cs-popup__tile-label" translate>label_support_hours</span>
          <span class="cs-popup__tile-value">{{ supportHours }}</span>
        </div>
      </div>
      <span class="cs-popup__hours-badge" *ngIf="isOpenNow" translate>label_open_now</span>
      <span class="cs-popup__hours-badge is-closed" *ngIf="!isOpenNow" translate>label_closed_now</span>
    </div>

    <p class="cs-popup__footer">
      <span translate>label_powered_by_prefix</span>
      <strong>{{ poweredByName }}</strong>
      <span translate>label_support_response_sla</span>
    </p>
  </div>
</div>
